import React from 'react';
import PropTypes from 'prop-types';

import { Image } from '../atoms';

export function HeroImage({ image, className }) {
  return (
    <div className="w-full">
      <Image
        data={image}
        className={`w-full h-64 rounded sm:h-80 xl:h-120 ${className}`}
        imgStyle={{ objectFit: 'cover' }}
      />
    </div>
  );
}

HeroImage.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  image: PropTypes.object.isRequired,
  className: PropTypes.string,
};

HeroImage.defaultProps = {
  className: null,
};
